import React, { JSX } from "react";
import Icon from "../icons/Icon";
import { IconLibrary } from "../../../interfaces/icon/IconLibrary";
import { IFilterStyleButton } from "../../../interfaces/buttons/buttons";

const FilterStyleButton = ({className, isDisabled, ariaLabel, onButtonClick, content}: IFilterStyleButton) => {
    const defaultContent = <>Filter <Icon iconName={IconLibrary.FILTERS} color="var(--thriveSky)" sizeInPx={"16"}/></>
    return (
        <button
            className={`filter-style-button ${className ?? ""}`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
        >
            {content ?? defaultContent}        
        </button>
    );
};

export default FilterStyleButton